import React, { useContext, useEffect, useRef } from "react";
import { Input } from "../../../../controls";
import { InputAdornment } from "@mui/material";
import { AppContext } from "App";

const AmountToPay = ({ error, cartData, received, setReceived }) => {
  const receiveRef = useRef();
  const { settings } = useContext(AppContext);

  const inputBoxFocus = () => {
    setTimeout(() => {
      if (receiveRef.current) {
        receiveRef.current.focus();
        receiveRef.current.select();
      }
    }, 10);
  };

  useEffect(() => {
    setReceived(cartData.netPayable || 0);

    // Focus on the input box
    inputBoxFocus();
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData.netPayable]);

  useEffect(() => {
    setReceived(
      (
        parseFloat(cartData.netPayable) - parseFloat(cartData.received || 0)
      ).toFixed(2)
    );
    inputBoxFocus();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData.received]);

  const handleInpChg = (e) => {
    setReceived(e.target.value);
  };

  const handleFocus = (e) => {
    e.target.select();
  };

  return (
    <>
      <Input
        fullWidth
        placeholder="0.000"
        name="received"
        value={received}
        error={error}
        type="number"
        variant="outlined"
        size="small"
        onChange={handleInpChg}
        onFocus={handleFocus} // Handles text selection on focus
        InputProps={{
          inputRef: receiveRef,
          className: "!text-2xl md:!text-3xl !font-semibold !text-gray-500",
          startAdornment: (
            <InputAdornment position="start">
              <span className="text-2xl md:text-3xl text-gray-500">
                {settings?.currSymbol}
              </span>
            </InputAdornment>
          ),
        }}
      />
      <span className="text-[12px] p-1 font-medium text-primary">
        Edit to make a partial payment
      </span>
    </>
  );
};

export default AmountToPay;
